
export const externalConstants = {
  GOOGLE_MAP_API_KEY: "",
};

export const authConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
};

export const defaultAreaTypes = {
  NORMAL: "일반",
  COMPACT: "경차",
  ELECTRIC: "전기차",
  HANDICAP: "장애인",
  MATERNITY: "임산부",
  FEMALE: "여성",
  RESIDENCE: "거주자",
};

export default {
  authConstants,
  externalConstants,
  defaultAreaTypes,
};
